import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import moment from "moment"
import { initReactI18next } from "react-i18next"

// Import moment locales
import "moment/locale/fr" // French locale

// Import translation files
import enTranslations from "../i18n/en.json"
import frTranslations from "../i18n/fr.json"

const resources = {
  en: {
    translation: enTranslations,
  },
  fr: {
    translation: frTranslations,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Configure language detection to use query parameters
    detection: {
      order: ["querystring"],
      lookupQuerystring: "ui_locales", // Look for ?ui_locales=en or ?ui_locales=fr
      caches: [], // Remember choice in localStorage
    },
  })

// Sync moment locale with i18n language changes
i18n.on("languageChanged", (lng) => {
  moment.locale(lng)
})

// Set initial moment locale
moment.locale(i18n.language)

export default i18n
